module.exports = __webpack_public_path__ + "static/media/traycorp11.031f308f.png";